import React,{Component} from 'react';
import { Modal, Row, Col, Spin, Form,Select, Input } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createHideTaskNoteModel,asyncTaskNoteUpdate,asynctaskNoteAdd} from './actions';
import Diff from './diff';
import moment from 'moment';
const FormItem = Form.Item;
const { TextArea } = Input;
const formItemLayout = {
    labelCol: { span: 4, offset: 2 },
    wrapperCol: { span: 16 },
};
class TaskNote extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
    };
    formatFormData = values => {
        let result = {};
        Object.keys(values).forEach(key => {
            if (typeof values[key] !== 'undefined') {
                if (values[key] instanceof moment) {
                    result[key] = moment(values[key].valueOf()).format('YYYY-MM-DD');
                } else {
                    result[key] = values[key];
                }
            }
        });
        return result;
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if (this.props.taskNote._id === undefined) {
                    await this.props.asyncAdd(this.formatFormData(values));
                } else {
                    values["_id"] = this.props.taskNote._id;
                    await this.props.asyncUpdate(this.formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { showTaskNoteModel, taskNote } = this.props;
        const { getFieldDecorator } = this.props.form;
        const pricpleOptin = this.props.userList.map(item => {
            return (
                <Option key={item.name} value={item.name}>
                    {item.name}
                </Option>
            );
        });
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="eId">
                            {getFieldDecorator('eId', {
                                initialValue: taskNote.eId,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入广告id ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled={true} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="ps">
                            {getFieldDecorator('ps', {
                                initialValue: taskNote.ps ,
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入整数',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="taskType">
                            {getFieldDecorator('taskType', {
                                initialValue: taskNote.taskType,
                            })(
                               // <Input placeholder="请填写" style={{ width: '100%' }} />,
                                <Select>
                                    <Option value="EV">曝光</Option>
                                    <Option value="CLICK">点击</Option>
                                    <Option value='APPLAUNCH'>APP拉起</Option>
                                    <Option value='COMBINE_EV_CLICK'>合并</Option>
                                    <Option value='APP_RETAIN'>注册留存</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="责任人">
                            {getFieldDecorator('pricple', {
                                initialValue: taskNote.pricple ,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入责任人',
                                    },
                                ],
                            })(
                               // <Input placeholder="请填写" style={{ width: '100%' }} />,
                                <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                    {pricpleOptin}
                                </Select>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="备注">
                            {getFieldDecorator('notes', {
                                initialValue: taskNote.notes,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入备注',
                                    },
                                ],
                            })(
                                <TextArea rows={15} placeholder="请填写备注" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="任务备注"
                    visible={showTaskNoteModel}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                        {form}
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    showTaskNoteModel: state.tasklist.taskNotes.showTaskNoteModel,
    taskNote:state.tasklist.taskNotes.taskNote,
    userList: state.tasklist.UserList,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(createHideTaskNoteModel( false)),
    asyncUpdate: contents => dispatch(asyncTaskNoteUpdate(contents)),
    asyncAdd: contents => dispatch(asynctaskNoteAdd(contents)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(TaskNote));



// WEBPACK FOOTER //
// ./pages/task/tasklist/taskNote.js